import $ from "jquery";

export const RoleSelected = function () {
	const $root = $(".role-selected");
	if (!$root.length) {
		return false;
	}

	const $next = $root.find(".js-role-selected-next");
	const nextUrl = $root.attr("data-next-url") || "";

	const goNext = () => {
		if (nextUrl) {
			window.location.href = nextUrl;
		}
	};

	$next.on("click", function () {
		if ($next.hasClass("is-loading") || !nextUrl) {
			return;
		}

		goNext();
	});
};
